<template>
  <div class="merchant">
    <div class="cashalo-div">
      <img src="../assets/cashalo.svg" alt="">
      <a class="backtohome" href="https://www.cashalo.com/">Back to Home</a>
    </div>
    <div class="waves"></div>
    <div class="circle-right"></div>
    <div class="circle-left"></div>
      <merchant-logo />
      <merchant-form />
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  components: {
    'merchant-form': () => import("@/views/Form.vue"),
    'merchant-logo': () => import("@/views/MerchantLogo.vue"),
  },
  name: 'merchant',
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
}
</script>
